const gaSectionType = {
    sg: "studyGroup",
    tools: "tools",
    meet: "enterMeet",
};

export default gaSectionType;
